export enum MerchantType {
	ONLINE = 'ONLINE_MERCHANT',
	OFFLINE = 'OFFLINE_MERCHANT',
	FASTAG = 'FASTAG',
}

export type TMerchantAttributeType =
	| 'MCC'
	| 'SUBMERCHANT'
	| 'MERCHANT_LEAD_TYPE'
	| 'SUPERCATEGORY'
	| 'CATEGORY'
	| 'SUBCATEGORY'
	| 'SUPERMERCHANT'
	| 'OFFER_LABEL'
	| 'CATEGORY_TAG'
	| 'UPI_VERIFIED'
	| 'TRANSACTION_SMS_NOTIFICATION_ENABLED'
	| 'PAN_NOT_AVAILABLE'
	| 'SETTLEMENT'
	| 'ONDEMAND_SETTLEMENT'
	| 'ACCOUNT_ACCESS'
	| 'ENCRYPTED_ACCOUNT_DETAILS_ACCESS'
	| 'UPI_ACCOUNT_ACCESS_FOR_NACH'
	| 'SUPPORT_PRIORITY'
	| 'CHAT_ENABLED'
	| 'CHAT_FEATURE_SET'
	| 'CASHOUT_ENABLED'
	| 'SMS_NOTIFICATION_RECEIVER_LIMIT'
	| 'EMAIL_NOTIFICATION_RECEIVER_LIMIT'
	| 'POST_ENABLED'
	| 'PROVIDE_GSTIN_IN_TRANSACTION_CONTEXT'
	| 'TRANSACTION_STATUS_LAZY_PUBLISHING_ALLOWED'
	| 'EASY_CHECKOUT_ENABLED'
	| 'SETTLEMENT_MODES'
	| 'MO_DERIVED_KYC_TAG'
	| 'UNKNOWN_MERCHANT_ATTRIBUTE'
	| 'DERIVED_BIZ_SIZE'
	| 'BIZ_SIZE_OVERIDDEN'
	| 'POB_NOT_AVAILABLE'
	| 'DEALER_CODE'
	| 'SPLIT_SETTLEMENT_ENABLED';

export interface IMerchantAttribute {
	active: boolean;
	createAt: EpochTimeStamp;
	merchantId: string;
	type: TMerchantAttributeType;
	updatedAt: EpochTimeStamp;
	value: string;
	version: number;
}

export interface IMerchantInfo {
	name: string;
	roleId: string;
	description: string;
	namespace: string;
	groupName: string;
	groupValue: string;
	active: boolean;
	createdBy: string;
	createdAt: EpochTimeStamp;
	updatedAt: EpochTimeStamp;
}

export interface IMerchantIntegrationState {
	onboardingState: string;
	lastTransactionTime?: string;
}
